import React from 'react';

/**
 * Компонент формы входа в комнату чата.
 * Держит только разметку и делегирует обработчики родителю, чтобы не менять текущую логику.
 */
const JoinForm = ({ roomId, username, onUsernameChange, onSubmit }) => {
  return (
    <div className="login-container">
      <h1>💬 Вход в чат</h1>
      <div className="room-info">
        <h2>Комната: {roomId}</h2>
        <div className="room-info-card">
          <p className="room-info-main-text">
            <strong>Важно:</strong> Для анонимности к имени добавится уникальный номер
          </p>
          <p className="room-info-example-text">
            Будет отображаться как: <strong>Влад</strong><span className="username-example-suffix">#8844</span>
          </p>
          <p className="room-info-note-text">
            При каждом входе номер будет новым
          </p>
        </div>
      </div>
      <form onSubmit={onSubmit}>
        <div className="form-group">
          <label htmlFor="username">Как вас называть:</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={onUsernameChange}
            placeholder="Введите ваше имя"
            required
            autoFocus
            maxLength={20}
          />
        </div>

        <button type="submit" className="login-btn">
          Войти в чат
        </button>
      </form>
    </div>
  );
};

export default JoinForm;


